/* eslint-disable import/no-named-as-default */
import React from "react";
import { Provider } from "react-redux";
import PropTypes from "prop-types";
import store from "../../store";
import EmployerPerformanceMetrics from "./EmployerPerformanceMetrics";

const ProviderComponent = ({ companyId }) => (
  <Provider store={store}>
    <EmployerPerformanceMetrics companyId={companyId} />
  </Provider>
);

ProviderComponent.propTypes = {
  companyId: PropTypes.number.isRequired,
};

export default ProviderComponent;
